import { type VendorInvite } from '@webapp/modules/vendor/data-access/types/VendorInvite'

/**
 * A vendor can hold several invite rows at once (re-invites after an expiry or
 * a manual cancellation each add one). The Vendor Details pane is driven by a
 * single invite, and that invite is the most recently created one: the only
 * row whose lifecycle is still live. `createdAt` is the one timestamp every
 * row carries; equal timestamps keep the order the API returned.
 */
export const selectLatestVendorInvite = (
  invites: VendorInvite[]
): Nullable<VendorInvite> =>
  invites.reduce<Nullable<VendorInvite>>(
    (latest, invite) =>
      latest &&
      new Date(latest.createdAt).getTime() >=
        new Date(invite.createdAt).getTime()
        ? latest
        : invite,
    null
  )
